module.exports = __webpack_public_path__ + "img/zshj_cl3.12bd80ce.png";